export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    type: 'radio',
    align: 'center',
    fixed: 'left',
    width: 50
  },
  {
    type: 'expand',
    align: 'center',
    width: 60,
    title: '展开',
    slots: {
      content: 'expandContent',
    },
  },
  {
    field: 'transferRuleName',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    title: '中转策略名称',
    showOverflow: 'ellipsis'
  },
  {
    field: 'transferRuleType',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    title: '中转策略类型',
    showOverflow: 'ellipsis'
  },
  {
    field: 'custName',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    title: '客户名称',
    showOverflow: 'ellipsis'
  },
  {
    field: 'originProvinceName',
    align: 'center',
    width: 100,
    title: '始发地省份',
    showOverflow: 'ellipsis'
  },
  {
    field: 'originCityName',
    align: 'center',
    width: 100,
    title: '始发地城市',
    showOverflow: 'ellipsis'
  },
  {
    field: 'originDistrictName',
    align: 'center',
    width: 100,
    title: '始发地区县',
    showOverflow: 'ellipsis'
  },
  {
    field: 'destinationProvinceName',
    align: 'center',
    width: 100,
    title: '目的地省份',
    showOverflow: 'ellipsis'
  },
  {
    field: 'destinationCityName',
    align: 'center',
    width: 100,
    title: '目的地城市',
    showOverflow: 'ellipsis'
  },
  {
    field: 'destinationDistrictName',
    align: 'center',
    width: 100,
    title: '目的地区县',
    showOverflow: 'ellipsis'
  },
  {
    field: 'transferRuleRemarks',
    align: 'center',
    width: 192,
    title: '备注信息',
    showOverflow: 'ellipsis'
  },

]
